module.exports = __webpack_public_path__ + "img/wdct2x.838339ee.png";